import Contact from "../../../entities/contact";
import {
    BankAccountHolderType,
    BankAccountType,
    CardPaymentMethodNames,
    PaymentMethods,
    PaymentType,
    PayrixAddress,
    PayrixDateYearMonthDayHourSecondMillis,
    PayrixEntity,
    PayrixPaymentExpanded,
    PayrixPaymentMethod,
    ZPayrixPaymentMethod,
} from "../../../@types/payrix";
import {LawpayBankAccountType, LawpayPaymentMethod} from "../../../@types/lawpay";
import Address from "../../../entities/address";
import {PaymentAddress, StandardAddress} from "./PaymentMethodOld";
import {PaymentMethod} from "../../../@types/payments";


export function getAddress(pa: PaymentAddress): StandardAddress {
    return new Address({
        street: pa.street || pa.line1 || pa.address1,
        unit: pa.unit || pa.line2 || pa.address2,
        city: pa.city,
        state: pa.state || pa.state_or_province,
        zip: pa.zip || pa.postal_code,
        country: pa.country || pa.country_code,
    });
}

export function addressMatch(a: PaymentAddress, b: PaymentAddress): boolean {
    return a.street === b.street &&
        a.unit === b.unit &&
        a.city === b.city &&
        a.state === b.state &&
        a.zip === b.zip &&
        a.country === b.country;
}

class BasePaymentMethod implements PaymentMethod {
    public type: PaymentType; // bank or card
    public id: PayrixEntity; // This is the ID of the TOKEN, e.g. p1_tok_...
    public paymentToken: string; // This is the actual token, from token.token
    public created?: PayrixDateYearMonthDayHourSecondMillis;
    public modified?: PayrixDateYearMonthDayHourSecondMillis;
    public description?: string;
    public accountType: BankAccountType | CardPaymentMethodNames;
    public accountHolderType?: BankAccountHolderType;
    public cardType?: CardPaymentMethodNames;
    public number: string // card or bank account number (Should be all digits)
    public routing?: string;
    public method: PaymentMethods;
    public expMonth?: string; // 2 digits
    public expYear?: string; // 4 digits
    public cvv?: string; // 3-4 digits, only used when creating a new method
    public nameOnCard: string;
    public nickname?: string; // e.g. Frost Bank
    public phone?: string;
    public email: string;
    public custom: PayrixPaymentExpanded;
    public address: PayrixAddress; // Outlaw Address
    public contact: Contact;
    public expiration?: string;

    constructor(type: PaymentType) {
        this.type = type;
    }

    public fromPayrix(pm: PayrixPaymentMethod) {
        this.id = pm.id;
        this.paymentToken = pm.paymentToken;
        this.created = pm.created;
        this.modified = pm.modified;
        this.description = pm.description;
        this.accountType = pm.accountType;
        this.accountHolderType = pm.accountHolderType;
        this.cardType = pm.cardType;
        this.number = pm.number;
        this.routing = pm.routing;
        this.method = pm.method;
        this.expMonth = pm.expMonth;
        this.expYear = pm.expYear;
        this.nameOnCard = pm.nameOnCard;
        this.nickname = pm.nickname;
        this.phone = pm.phone;
        this.email = pm.email;
        this.custom = pm.custom;
        this.address = pm.address;
        this.contact = pm.contact;
        this.expiration = pm.expiration;
    }

    get paymentType() {
        return this.method;
    }

    set paymentType(method: PaymentMethods) {
        this.method = method;
    }

    get routingNumber() {
        return this.routing || this.custom.routing;
    }

    get accountNumber() {
        return this.number || this.custom.number;
    }

    public fromLawpay(pm: LawpayPaymentMethod) {

    }

    public toLawpay(): LawpayPaymentMethod {
        // TODO: Need to fix this!
        return {
            id: this.id,
            saved_payment_token: this.paymentToken,
            bank_account_type: this.accountType.toLowerCase() as LawpayBankAccountType,
            account_holder_type: null, // this.accountHolderType as LawpayAccountHolderType,
            payment_type: null,
            address: {
                line1: this.address.address1,
                line2: this.address.address2,
                city: this.address.city,
                state: this.address.state,
                postal_code: this.address.zip,
                country: this.address.country,
                // preferred: true, Not sure if we should be setting this
                type: "address"
            }
        } as LawpayPaymentMethod;
    }

    hasProblems() {
        const result = ZPayrixPaymentMethod.safeParse(this);
        if (result.success) return false;
        else return result.error;
    }

    isBankAccount() {
        return this.type === 'bank';
    }

    isCard() {
        return this.type === 'card';
    }

}

export default BasePaymentMethod;

